import React, { useEffect, useRef } from 'react';
import bwipjs from 'bwip-js';

const DataMatrixBarcode = ({ value, size = 100 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    try {
      bwipjs.toCanvas(canvasRef.current, {
        bcid: 'datamatrix',     // Тип штрихкода: DataMatrix
        text: value.toString(), // Значение для кодирования
        scale: 3,               // Коэффициент масштабирования
        padding: 2,             // Небольшие отступы (можно регулировать)
        includetext: false,     // Текст под штрихкодом не нужен
      });
    } catch (error) {
      console.error('Ошибка генерации DataMatrix:', error);
    }
  }, [value]);

  return (
    <div 
      style={{ 
        width: `${size}px`, 
        height: `${size}px`, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}
    >
      <canvas ref={canvasRef} style={{ maxWidth: '100%', maxHeight: '100%' }} />
    </div>
  );
};

export default DataMatrixBarcode;
